import LTR from "@brand-icons/global/sound-off/sound-off-ltr.svg";

import { iconFactory } from "../iconFactory";

export const SoundOffIcon = iconFactory("SoundOffIcon", LTR);
